import RFQProposalStages from 'components/rfq/rfq-proposal-checklist';
import React from 'react';

const RFQProposalChecklistPage = (): JSX.Element => {
  return <RFQProposalStages />;
};

export default RFQProposalChecklistPage;
